export default "__VITE_ASSET__c2f0e886__"